import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import type { PhotoActionHandlerActionProps } from './PhotoActionHandlers'
import { useDispatchPhotoActionMutation } from './useDispatchPhotoActionMutation'
import { Button } from '@jotta/ui/Button'
import { useCallback } from 'react'

const debug = Debug('jotta:photos:action:DownloadPhotos')

export const ActionDownloadPhotos = observer<
  PhotoActionHandlerActionProps<'DOWNLOAD_PHOTOS'>
>(function ActionDownloadPhotos({
  action,
  getDownloadInfo,
  photoIds,
  dispatch,
  buttonClass,
}) {
  const { mutateAsync, isPending } = useDispatchPhotoActionMutation(
    'DOWNLOAD_PHOTOS',
    undefined,
    dispatch,
  )

  const onClick = useCallback(() => {
    if (getDownloadInfo) {
      mutateAsync([
        getDownloadInfo(photoIds && photoIds.length ? photoIds : undefined),
      ])
    }
  }, [mutateAsync, getDownloadInfo, photoIds])

  return (
    <Button
      aria-label={action.label}
      data-testid={action.testid}
      aria-busy={isPending}
      key={action.actionType}
      className={buttonClass}
      icon={action.icon}
      onClick={onClick}
    >
      {action.label}
    </Button>
  )
})
